import 'apps/hiring/styles/components/evaluate-applicant-list.scss';
import 'library/styles/global/rotate.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'library/util/core-router';
import { resolve } from 'library/helpers/path-resolver';
import AlertSvg from 'library/icons/alert.svg';
import DownloadReportButton from 'library/components/download-report';
import PathSvg from 'library/icons/path.svg';
import Collapsable from 'library/components/collapsable';
import Select from 'library/components/form-elements/select';
import CopyButton from 'library/components/copy-button';
import { applicantActions } from 'apps/hiring/services/applicant-status';
import withData from 'util/hoc/with-data';
import useShowMorePages from 'util/hoc/useShowMorePages';
import PeopleList from 'apps/hiring/components/evaluate-people/people-list';
import Caret from 'library/icons/caret.svg';
import MailSvg from 'library/icons/mail.svg';
import DownloadSvg from 'library/icons/download.svg';
import TargetsSvg from 'library/icons/targets.svg';

class EvaluateApplicantList extends React.Component {
  static propTypes = {
    noMatchScore: PropTypes.bool,
    noSort: PropTypes.bool,
    onMouseOver: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onApplicantSelect: PropTypes.func,
    loading: PropTypes.bool,
    active_applicant: PropTypes.number,
    openingId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tags: PropTypes.array,
    hire: PropTypes.func,
    reject: PropTypes.func,
    reload: PropTypes.func,
    openingName: PropTypes.func,
    activeTarget: PropTypes.string,
    graph_loading: PropTypes.bool.isRequired,
    graph_data: PropTypes.any,
    graph_update: PropTypes.func,
    query: PropTypes.func.isRequired,
    parseQuery: PropTypes.func,
    pageSize: PropTypes.number,
    match: PropTypes.object
  }

  static defaultProps = {
    tags: [],
    onMouseOver: ()=>null,
    onMouseLeave: ()=>null,
    onApplicantSelect: ()=>null,
    pageSize: 15
  }

  state = {
    sortBy: 'match',
    sortOrder: 'desc',
    limit: 15,
    search: '',
    loading: false
  }


  updateApplicantStatus = async (value) => {
    this.setState({ saving: true });

    const { id, status, user_id } = value._data.value;

    await resolve(
      applicantActions,
      status,
      ()=>{console.error(`Status: ${status} does not have a function`)}
    )(
      id, status == 'Hire' ? this.props.openingId : null, status == 'Hire' ? user_id : null
    );

    this.setState({ saving: false });
    this.props.reload(true, true);
  }

  emailApplicant = (id) => {
    const applicant = resolve(this.props, 'graph_data/applications', []).filter(c => c.id === id);
    const email = resolve(applicant, '0/user/email', '');
    document.location = `mailto: ${email}?subject=${this.props.openingName}`;
  }

  disabledResumeButton = (id) => {
    const applicant = resolve(this.props, 'graph_data/applications', []).filter(c => c.id === id);
    if (resolve(applicant, '0/resume_url', '') === null) return true;
    return false;
  }

  compareValue = (a,b) => {
    let comparison = 0;
    if (a.match> b.match) {
      comparison = 1;
    } else if (a.match < b.match) {
      comparison = -1;
    }
    return (
      (this.state.sortOrder === 'desc') ?
        (comparison * -1) : comparison
    );
  }

  load = async () => {
    try {
      this.setState({ loading: true});
      const { data } = await this.props.query({
        limit: this.state.limit,
        name: this.state.search,
        surveyed: true,
        match: this.props.match
      });

      this.props.graph_update(data);

      this.setState({ loading: false});
    } catch (e) {
      console.error(e);
    }
  }

  mapApplicants = ({ id, user, match = null, assessment, resume_url, status }) => (
    <div
      onMouseOver={()=>this.props.onMouseOver(user.id)}
      key={id}
      onClick={()=>this.props.onApplicantSelect(id, user.id)}
      className={[
        'hiring-evaluate-sidebar-item',
        this.props.loading?'loading':null, this.props.active_applicant===id?'active':null].filter(c=>c).join(' ')}
    >
      {
        this.props.tags.filter(t=>t.id===id).map(t=>t.tag)
      }
      <span className="hiring-evaluate-sidebar-item-name">{ user.first_name }</span>
      <span className="hiring-evaluate-sidebar-item-name">{ user.last_name }</span>
      {
        parseInt(resolve(assessment, 'validity_score', 0)) < 100
          ? (
            <span
              data-tooltip={`${resolve(assessment, 'validity_score', 0)}% valid`}
              data-tooltip-position="top"
            >
              <AlertSvg
                className="hiring-survey-status-flag-warning"
                style={{width: '1em', height: '1em'}}
              />
            </span>
          )
          : null
      }


      <span className="hiring-evaluate-sidebar-item-match">{ match }</span>
      <span>
        <Link to={`/hiring/openings/${this.props.openingId}/applicants/${id}`}>
          <PathSvg />
        </Link>
      </span>

      <Collapsable className="hiring-evaluate-sidebar-item-controls" collapsed={this.props.active_applicant!==id}>
        <div className="hiring-evaluate-sidebar-item-controls-inner">
          <div className="applicant-select-label-title">
            <div className="applicant-select-label label">
              {status == 'Applied' ? 'Undecided': status}
            </div>
            <Select onChange={this.updateApplicantStatus} className={'applicant-select-label select'} label={<Caret />}>
              <p value={{status:'Hire', id:id, user_id: resolve(user, 'id', null)}}> Hire </p>
              <p value={{status:'Archive', id:id, user_id: resolve(user, 'id', null)}}> Archive </p>
              <p value={{status:'Reject', id:id, user_id: resolve(user, 'id', null)}}> Reject </p>
            </Select>
          </div>
          <div className="applicant-select-label-icons">
            <CopyButton
              component='span'
              value={resolve(user, 'email', '')}>
              <MailSvg />
            </CopyButton>
            <DownloadSvg disabled={resume_url === null} onClick={() => resume_url === null ? null :  window.open(resume_url)} />
            <DownloadReportButton
              reportType="readiness"
              key={`${this.props.activeTarget}-${this.props.openingId}`}
              data={{user_id: Number(resolve(user, 'id', null)), opening_id: Number(this.props.openingId), target_id: Number(this.props.activeTarget)}}
              component='span'>
              <TargetsSvg />
            </DownloadReportButton>
          </div>
        </div>
      </Collapsable>
    </div>
  )

  reloadWithSortOptions = async (sortBy, sortOrder) => {
    try {
      this.setState({ loading: true });
      if(sortBy) this.setState({sortBy: sortBy});
      if(sortOrder) this.setState({sortOrder: sortOrder});
      if(sortBy !== 'match') {

        const newProps = {...this.props};
        newProps.sort_by = sortBy ? sortBy : this.state.sortBy;
        newProps.sort_order = sortOrder ? sortOrder : this.state.sortOrder;
        newProps.limit = this.state.limit;
        newProps.name = this.state.search;
        newProps.surveyed = true;
        newProps.match = this.props.match;
        const { data } = await EvaluateApplicantList.query(null, newProps);
        this.props.graph_update(data);
      }

      this.setState({ loading: false});
    } catch (e) {
      console.error(e);
    }
  };



  renderShowMorePages = () => {
    const { graph_loading, graph_data } = this.props;

    const count = Math.min(resolve(graph_data, 'users/results', []).length, this.state.limit);
    const total = resolve(graph_data, 'users/pagination/total', null);

    return useShowMorePages({
      count,
      loading: graph_loading || this.state.loading,
      total,
      setLimit: this.setLimit,
      limit: this.state.limit
    });
  }

  setLimit = (limit) => {
    if(this.state.sortBy === 'match') this.setState({sortBy: 'first_name'}); //can't query for match stuff
    this.setState({limit: limit}, this.reloadWithSortOptions);
  }

  render() {
    const {
      graph_data,
      graph_loading,
      graph_update,
      loading,
      onMouseLeave,
      noMatchScore,
      noSort,
      setLimit
    } = this.props;

    const { sortUpMatch, sortUpFirstName, sortUpLastName } = this.state;
    const peopleList = resolve(graph_data, 'applications', []);
    if(this.state.sortBy === 'match') peopleList.sort(this.compareValue);

    return (
      <PeopleList
        graph_data={graph_data}
        graph_results_resolve_path='users/results'
        graph_loading={graph_loading}
        onMouseLeave={onMouseLeave}
        loading={loading}
        limit={this.state.limit}
        mapPeople={this.mapApplicants}
        peopleList={peopleList}
        handleSort={this.reloadWithSortOptions}
        currentSortColumn={this.state.sortBy}
        sortDirection={this.state.sortOrder}
        setLimit={this.setLimit}
        noMatchScore={noMatchScore}
        noSort={noSort}
      />
    );
  }
}

EvaluateApplicantList.query = async (token, { query='', limit, pageSize = 15, match, sort_by, sort_order}) => (
  await query({
    limit: limit ? limit : pageSize,
    surveyed: true,
    match: match,
    sort_by: sort_by,
    sort_order: sort_order
  })
);

EvaluateApplicantList.parseQueryData = async (data, { parseQuery=(d)=>d }) => (
  await parseQuery(data)
);

export default withData(EvaluateApplicantList);
